export const name = 'builderModuleLoader' as const

export const ReactTemplateSymbol = Symbol('ReactTemplateSymbol')
export const ESMLoaderSymbol = Symbol('ESMLoaderSymbol')
export const PromiseCacheSymbol = Symbol('PromiseCacheSymbol')
export const ImportMapSymbol = Symbol('ImportMapSymbol')
export const EsModuleShimsRuntimeStateSymbol = Symbol('EsModuleShimsRuntimeState')
